// import { DashboardCmsSection } from '@/data/cms/dump/dashboard.dump';
import React, { useMemo } from 'react';
import PolicyDetails from './sections/policyDetails/policyDetails';
import QuickActions from './sections/mini-quick-actions/miniQuickActions';
import NeedAnySupport from './sections/need-any-support/needAnySupport';
import LatestInHdfc from './sections/latest-in-hdfc/latestInHdfc';
import NeedsYourAttention from './sections/needs-your-attention/needsYourAttention';
import ResumeJourney from './sections/resume-journey/resumeJourney';
import BuyInsurance from './sections/buy-insurance/buyInsurance';
import LocateServices from './sections/locateServices/locateServices';
import PromotionBanner from './sections/promotionBanner/promotionBanner';
import Contact from './sections/contact/contact';
import { DashboardCmsSection } from './types/dashboard.types';

export const dashboardMapper: Record<
  DashboardCmsSection['type'],
  React.ComponentType<{}>
> = {
  resumeJourney: ResumeJourney,
  needsYourAttention: NeedsYourAttention,
  policy: PolicyDetails,
  actions: QuickActions,
  support: NeedAnySupport.dashboard,
  latest: LatestInHdfc,
  buyNewInsurance: BuyInsurance.dashboard,
  contact: Contact.dashboard,
  locateServices: LocateServices,
  promotionalBanner: PromotionBanner.dashboard,
};

const DashboardMapper = ({ type }: { type: DashboardCmsSection['type'] }) => {
  const Comp = useMemo(() => dashboardMapper[type], [type]);
  return <Comp />;
};

export default DashboardMapper;
